'use strict';

var angular = require('angular');
var dependencies = [];
module.exports = angular.module('AVRO.Widgets.Modal', dependencies).controller('ModalController', require('./controllers/ModalController')).directive('rmModal', require('./directives/ModalDirective'));